<script lang="ts" setup>
import { WifiOffIcon } from 'lucide-vue-next';

import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import InfoBox from '@sigma/ui/InfoBox.vue';
import StickyElement from '@sigma/ui/StickyElement.vue';

import * as l from './ChatOfflineFooter.loc.js';

const t = useTranslate();
</script>

<template>
  <StickyElement
    v-slot="{ pinned }"
    position="bottom"
    :shadow="false"
  >
    <InfoBox
      color="red"
      :class="[css.offline, pinned && css.offline_sticky]"
      :icon="WifiOffIcon"
      border
    >
      <template #title>{{ t(l.offlineTitle) }}</template>
      {{ t(l.offlineMessage) }}
    </InfoBox>
  </StickyElement>
</template>

<style lang="scss" module="css">
.offline {
  pointer-events: auto;
  transition: box-shadow 0.15s ease-out;
  border-radius: $border-radius-16;
  margin-block: $spacing-16;

  @include media-max-md {
    margin: $spacing-16;
  }

  &_sticky {
    box-shadow:
      0 0 0 5px $color-white,
      $sticky-shadow;
  }
}
</style>
